(() => {
  const selector = '[data-interwood-featured-tabs]';

  const initialise = (section) => {
    if (!section || section.dataset.tabsInitialised === 'true') return;

    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));
    const viewAll = section.querySelector('[data-interwood-view-all]');
    if (!tabs.length || !panels.length) return;

    const hydratePanel = (panel) => {
      const template = panel.querySelector('[data-interwood-panel-template]');
      if (!template) return;
      panel.appendChild(template.content.cloneNode(true));
      template.remove();
      window.lazySizes?.loader?.checkElems();
    };

    const activate = (tab, moveFocus = false) => {
      const panel = section.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
      if (!panel) return;

      hydratePanel(panel);

      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        item.classList.toggle('is-active', active);
      });

      panels.forEach((item) => {
        item.hidden = item !== panel;
      });

      if (viewAll && tab.dataset.collectionUrl) {
        viewAll.href = tab.dataset.collectionUrl;
      }

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        activate(tabs[nextIndex], true);
      });
    });

    section.dataset.tabsInitialised = 'true';
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll(selector).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
